import { mixpanelTrackAction } from "./tracking";
import { onStartMainSurvey } from "./survey/onStartMainSurvey";
import { onCompleteMainSurvey } from "./survey/onCompleteMainSurvey";

import { GoToPageOptions } from "../goto/page-set";
import { onStartPaymentSurvey } from "./survey/onStartPaymentSurvey";
import { onCompletePaymentSurvey } from "./survey/onCompletePaymentSurvey";

export type ActionHandlerParams = {
  params: JsonObject;
} & GoToPageOptions;

export type ActionHandler = (params: ActionHandlerParams) => void;

const ACTIONS: Record<string, ActionHandler> = {
  TRACK: mixpanelTrackAction,
  ON_START_MAIN_SURVEY: onStartMainSurvey,
  ON_COMPLETE_MAIN_SURVEY: onCompleteMainSurvey,
  ON_START_PAYMENT_SURVEY: onStartPaymentSurvey,
  ON_COMPLETE_PAYMENT_SURVEY: onCompletePaymentSurvey,
};

export default ACTIONS;
